import type { paths } from '@crossbeam/openapi';

import type { PartnerScore, PartnerScoreBucket } from '@/types/partners';

export const INDIVIDUAL_RECORD_PATH =
  '/v0.3/records/{source-id}/{source-primary-key}';

type ResponseUnionType =
  paths[typeof INDIVIDUAL_RECORD_PATH]['get']['responses'][200]['content']['application/json'];

type ResponseForSectionType<Section> = Extract<
  ResponseUnionType,
  { section: Section }
>;

export type RecordSectionParamType = ResponseUnionType['section'];
export type RecordSectionType = Exclude<RecordSectionParamType, 'all'>;

export type RecordFieldType =
  ResponseForSectionType<'master'>['own']['fields'][number];

export type RecordPaginationType =
  ResponseForSectionType<'master'>['partners']['pagination'];

export type RecordOwnBySectionType = {
  [Section in RecordSectionParamType]: ResponseForSectionType<Section>['own'];
};

export type RecordResponseType<Section extends RecordSectionParamType = 'all'> =
  ResponseForSectionType<Section>;

export type RecordPartnerType<Section extends RecordSectionParamType = 'all'> =
  RecordResponseType<Section>['partners']['items'][number];

export type RecordFiltersType = {
  partner_search: string;
  partner_org_ids: number[];
  partner_tag_ids: number[];
  partner_population_ids: number[];
  partner_score: PartnerScore | null;
  partner_score_bucket: PartnerScoreBucket | null;
};

export type RecordQueryType = {
  section?: RecordSectionType;
  page?: number;
  limit?: number;
  partner_search?: string;
  partner_org_ids?: number[];
  partner_tag_ids?: number[];
  partner_population_ids?: number[];
  partner_score?: PartnerScore | null;
  partner_score_bucket?: PartnerScoreBucket | null;
};

export type RecordOverviewPartnerType = {
  partner_organization_uuid: string;
  partner_name: string;
  shared_with_us_population_ids: number[];
  partner_score_bucket: PartnerScoreBucket;
  partner_account_owner: { name: string } | null;
  contacts_common_count: number;
  contacts_new_count: number;
  open_opportunities_count: number;
  data_source: { integration_type: string; label: string } | null;
  fields?: RecordFieldType[];
};
